import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function Hero() {
  return <header className="relative overflow-hidden bg-cream pb-12 pt-8 sm:pb-16 sm:pt-12" data-id="element-170" data-mp="cvl5b7gbpium">
      <div className="mx-auto w-full max-w-3xl px-4" data-id="element-171" data-mp="hvh0qiayg1yk">
        <div className="flex flex-col items-center gap-3" data-id="element-172" data-mp="hsusegg8pifa">
          <div className="flex items-center gap-2" data-id="element-173" data-mp="mszc0fcg2t9q">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-navy-900 text-lg" aria-hidden="true" data-id="element-174" data-mp="ms7olrt041uj">
              🦷
            </span>
            <span className="font-display text-xl font-bold text-navy-900" data-id="element-175" data-mp="vnndrvit9sts">Dr. Karito</span>
          </div>
          <span className="rounded-full bg-white px-3.5 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.1em] text-navy-800 ring-1 ring-navy-900/10 sm:text-xs" data-id="element-176" data-mp="10kxe467qnowe">
            Mechanics Decision Map™
          </span>
        </div>

        <h1 className="mt-7 text-center font-display text-[34px] font-bold leading-[1.08] text-navy-900 sm:text-5xl md:text-[56px]" data-id="element-177" data-mp="1ah8vham6r4xp">
          Structure complex orthodontic mechanics{' '}
          <em className="not-italic text-sky-600" data-id="element-178" data-mp="4qsqre7mx0m1">
            <span className="italic" data-id="element-179" data-mp="3vw2cuusicuqd">in under 15 minutes</span>
          </em>
        </h1>

        <p className="mx-auto mt-5 max-w-xl text-center text-[16px] leading-relaxed text-navy-800/80 sm:text-lg" data-id="element-180" data-mp="3ru7cptmbcne6">
          Stop starting with the appliance. Start with the force system. A step-by-step clinical decision
          system that helps you structure complex biomechanics and organize your reasoning before you
          activate. Includes <strong className="font-bold text-navy-900" data-id="element-181" data-mp="imo8hgqas5nu">6 premium volumes</strong>,{' '}
          <strong className="font-bold text-navy-900" data-id="element-182" data-mp="eme0xzmux76v">5 professional tools</strong>, and{' '}
          <strong className="font-bold text-navy-900" data-id="element-183" data-mp="1b5ldq33nqxmp">30+ decision maps, protocols and checklists</strong>.
        </p>

        <div className="mt-7" data-id="element-184" data-mp="16cs9rhg0jtbo">
          <img src="https://cdn.magicpatterns.com/uploads/cAVaTUicR47AhiNd2d2CCc/BIODECISION-EN.png" alt="Mechanics Decision Map™ complete digital system: six volumes, decision maps, checklists and bonus tools" className="mx-auto w-full max-w-2xl" width={1080} height={1080} data-id="element-185" data-mp="30m76c5bjcw63" />
        </div>

        <div className="mt-6" id="primary-cta" data-id="element-186" data-mp="2vte2djnw5rv2">
          <CTAButton size="large" label="Yes — I want Mechanics Decision Map™" subline="Instant digital access · One-time payment of $27 · Lifetime access · 7-day guarantee" data-id="element-187" data-mp="2huwixy50r1iy" />
        </div>

        <div className="mt-8" data-id="element-188" data-mp="27yjmisi3a9ki">
          <Countdown data-id="element-189" data-mp="27zmez4v28k2j" />
        </div>

        <p className="mx-auto mt-5 flex max-w-md items-center justify-center gap-2 rounded-xl bg-white px-4 py-3 text-center text-[12.5px] font-medium leading-snug text-navy-800/80 ring-1 ring-navy-900/10 sm:text-sm" data-id="element-190" data-mp="2cvjk0f0vi400">
          <GlobeIcon className="h-4 w-4 shrink-0 text-sky-600" aria-hidden="true" data-id="element-191" data-mp="b3onx7r3o82w" />
          Your currency is converted automatically based on your location.
        </p>

        <div className="mt-4" data-id="element-192" data-mp="1qofsfzbzjjc4">
          <ScarcityBar data-id="element-193" data-mp="1qp8pg8l56uh2" />
        </div>
      </div>
    </header>;
}